import React from "react";
import { Grid, Icon } from "semantic-ui-react";
import InputField from "../../../commonComponents/formComponents/inputField";
import DropDown from "../../../commonComponents/formComponents/dropDown";
import { useSelector,useDispatch } from "react-redux";
import DeleteIcon from "../../../commonComponents/deleteIcon";
import { validation } from '../../util/cdsFieldPatterns';
import {addPartiesTabWarnings,deletePartiesTabWarnings} from "../../actions/errorValidationActions";

const AuthorizationDetails=({item:{id,eoriNo,authorizationType,roleId},deleteData,updateData, saveData})=>{
 

  const authorisationType= useSelector((state) => state.DropDownValues.authorisationType);
  const isFormDisabled = false;
  const dispatch = useDispatch()
  const {declarationCat = ''} = useSelector((state) => state.Shipment) || []

  const getValidationError = React.useMemo(
    () => validation(declarationCat, 'partiesTab'),
    [declarationCat]
  )
  const addErrors = (level, value, fieldName) => {
    dispatch(addPartiesTabWarnings(level, value, fieldName))
  }
  const deleteErrors = (level, value, fieldName) => {
    dispatch(deletePartiesTabWarnings(level, value, fieldName))
  }


  
  return (
    <Grid.Row>
      <Grid.Column
        width="5"
        className="divFormFeild border-bottom b-rw-0"
      >
        <DropDown
          id={`authType${id}`}
          label="TYPE"
          boxNumber="3/39"
          disabled={isFormDisabled}
          className="field-bg dropdown100 addInfoCode"
          labelClass="text-none"
          isLabel={true}
          clearable
          data={authorisationType}
          value={authorizationType}
          onChange={(value) =>{
            saveData({id,authorizationType:value||" ",roleId})
            updateData(id,{"authorizationType":value?.trim()})}
          }
          
        />
      </Grid.Column>
      <Grid.Column
        width="10"
        className="divFormFeild  border-bottom "
      >
        <InputField
          isLabel={false}
          id={`authIdentification${id}`}
          type="text"
          label="IDENTIFICATION"
          boxNumber="3/39"
          value={eoriNo}
          errors={getValidationError("authorizationeoriNo",eoriNo)}
          className={"field-bg"}
          clearInput={false}
          clearable
          onChange={(value) => updateData(id,{"eoriNo":value})}
          onBlur={(value) => {saveData({id, eoriNo:eoriNo||" ",roleId})
          let err = getValidationError('authorizationeoriNo', eoriNo,'partiesTab')
                err.length
                  ? addErrors('partiesTab', err[0], 'authorizationeoriNo')
                  : deleteErrors('partiesTab', '', 'authorizationeoriNo')
        }}
          disabled={isFormDisabled}
        />
      </Grid.Column>
     
      <Grid.Column width="1" className="icon-delete-add-info">
          <DeleteIcon id={`deleteAuth${id}`} onClick={() => deleteData(id)} />
      </Grid.Column>
    </Grid.Row>
  );
}
export default React.memo(AuthorizationDetails)
